import React, {useEffect, useRef, useState} from "react";
import {FormControl, MenuItem, Select} from "@mui/material";
import cyclicShifts from "../plans/Cyclic_Shifts.png";
import passingSeasons from "../plans/Passing_Seasons.png";
import pathsOfTheFey from "../plans/Paths_Of_The_Fey.png";
import roilingRoots from "../plans/Roiling_Roots.png";
import surgeOfSlaughter from "../plans/Surge_Of_Slaughter.png";
import linkedLeyLines from "../plans/Linked_Ley_Lines.png";
import noxious from "../plans/Noxious_Nexus.png";
import theLiferoots from "../plans/The_Liferoots.png";
import bountifulEquinox from "../plans/Bountiful_Equinox.png";
import lifecycle from "../plans/Lifecycle.png";
import creepingCorruption from "../plans/Creeping_Corruption.png";
import graspOfThorns from "../plans/Grasp_Of_Thorns.png";


const planImages = [
    passingSeasons,
    pathsOfTheFey,
    roilingRoots,
    cyclicShifts,
    surgeOfSlaughter,
    linkedLeyLines,
    noxious,
    theLiferoots,
    bountifulEquinox,
    lifecycle,
    creepingCorruption,
    graspOfThorns
];
const Plans = () => {
    const canvasRef = useRef(null);
    const [shapes, setShapes] = useState([]);
    const [selected, setSelected] = useState([]);
    const [plan, setPlan] = useState(planImages[0]);

    const gridSize = 20; // Adjust grid spacing

    const handleCanvasClick = (event) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const x = (event.clientX - rect.left);
        const y = (event.clientY - rect.top);

        for (let i = 0; i < shapes.length; i++) {
            const shape = shapes[i];
            if (
                x >= shape.x &&
                x <= shape.x + shape.width &&
                y >= shape.y &&
                y <= shape.y + shape.height
            ) {
                handleShapeClick(i);
                return;
            }
        }

        setShapes([...shapes, {x, y, width: 5, height: 5}]);
        handleShapeClick(shapes.length)
    };

    const handleShapeClick = (index) => {
        if (selected.length === 0) {
            setSelected([index]);
        } else if (selected.length === 1) {
            setSelected([...selected, index]);
        } else {
            setSelected([]); // Reset selection
            setShapes([])
        }
    };

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const image = new Image();
        image.onload = () => {
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
            // Draw the grid
            ctx.strokeStyle = "#286060";
            ctx.lineWidth = 0.2;

            for (let x = 0; x <= canvas.width; x += gridSize) {
                ctx.beginPath();
                ctx.moveTo(x, 0);
                ctx.lineTo(x, canvas.height);
                ctx.stroke();
            }

            for (let y = 0; y <= canvas.height; y += gridSize) {
                ctx.beginPath();
                ctx.moveTo(0, y);
                ctx.lineTo(canvas.width, y);
                ctx.stroke();
            }

            // Draw the shapes
            shapes.forEach((shape, index) => {
                ctx.fillStyle = "black";
                ctx.fillRect(shape.x - 2.5, shape.y - 2.5, shape.width, shape.height);
            });

            if (selected.length === 2) {
                const shapeA = shapes[selected[0]];
                const shapeB = shapes[selected[1]];

                const distance = Math.sqrt(
                    Math.pow(shapeB.x - shapeA.x, 2) + Math.pow(shapeB.y - shapeA.y, 2)
                ) / 20;

                ctx.strokeStyle = "red";
                ctx.lineWidth = 5;
                ctx.beginPath();
                ctx.moveTo(shapeA.x, shapeA.y);
                ctx.lineTo(shapeB.x, shapeB.y);
                ctx.stroke();

                ctx.fillStyle = "white";
                ctx.font = "20px Arial";
                ctx.fillText(
                    `${distance.toFixed(2)} inches`,
                    (shapeA.x + shapeB.x) / 2,
                    (shapeA.y + shapeB.y) / 2
                );
            }
        }
        image.src = plan

    }, [shapes, plan, selected]);

    return (
        <div style={{margin: "10px", padding: "10px"}}>
            <p>Select the plan and then you can click between two points to measure</p>

            <FormControl>
                <Select
                    id="plan-select"
                    value={plan}
                    onChange={(event) => setPlan(event.target.value)}
                    variant="outlined">
                    {planImages.map((image, i) => <MenuItem
                        value={image}>{image.replaceAll(/.*media\/(.*?)\..*/g, "$1").replaceAll("_", " ")}</MenuItem>)}
                </Select>
            </FormControl>
            <canvas
                ref={canvasRef}
                width={60 * 20}
                height={44 * 20}
                style={{border: "1px solid black"}}
                onClick={handleCanvasClick}
            />
        </div>
    );
};

export default Plans;
